export interface Authenticator {
    getToken(): string;
    getServiceRegion(): ServiceRegion | undefined;
}

export interface ServiceRegion {
    hostname: string;
    description: string;
}

export interface AuthResponse {
    uid: string;
    token: string;
    refreshToken: string;
    uses2FA: boolean;
    privateKey: string;
    publicKey: string;
    roles: string[];
    region?: ServiceRegion;
}

// Create ws/wss URL from http/https base URL.
// If the service is regional, provide the region argument.
// If baseUrl is not absolute, the hostname may be extracted from the Window object.
export function getServiceWebsocketUrl(baseHttpUrl: string, region?: ServiceRegion): string {
    let url;

    if (!baseHttpUrl.startsWith('http')) {
        if (window.location.protocol === "https:")
            url = "wss:";
        else
            url = "ws:";

        // No hostname in baseHttpUrl -> extract from region or Window object
        const hostname = region.hostname || window.location.hostname;
        url += `//${hostname}:${window.location.port}${baseHttpUrl}`;
    } else {
        const urlObject = new URL(baseHttpUrl);
        urlObject.protocol = "wss:";

        if (region)
            urlObject.host = region.hostname;
        
        url = urlObject.toString();
    }

    return url;
}
